var map = {
	"./angbao-bonus-cny.webp": 2510,
	"./angbao-bonus-dewali.webp": 2511,
	"./angbao-bonus-mooncake.webp": 2512,
	"./angbao-bonus-thaipusam.webp": 2513,
	"./angbao-bonus.webp": 2514,
	"./anni-lucky-draw.webp": 2515,
	"./cny-angbao-bonus.webp": 2516,
	"./cny-lucky-draw.webp": 2517,
	"./cny-promo.webp": 2518,
	"./dewali-promo.webp": 2519,
	"./dongzhi-angbao-bonus.webp": 2520,
	"./fifa-logo.webp": 2521,
	"./fifa-prediction.webp": 2522,
	"./fifa-qna.webp": 2523,
	"./uefa-predic.webp": 2524,
	"./welcome-cny-bonus.webp": 2525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2509;